export type GreetingKey = 'GoodMorning' | 'GoodAfternoon' | 'GoodEvening';

/** Time-of-day greeting translation key, based on the local hour. */
export function getGreetingKey(): GreetingKey {
  const hour = new Date().getHours();
  if (hour < 12) return 'GoodMorning';
  if (hour < 18) return 'GoodAfternoon';
  return 'GoodEvening';
}
